import accountSettingsModule from '../accountSettingsModule';

function accountSettingsModalPhoneSetController(
  $scope,
  $log,
  $uibModalInstance,
  accountsService,
  numericCodeService,
  urlService,
  phoneService,
  phoneConstants,
  modalConstantsService
) {
  'ngInject';

  $scope.phoneInfo = {};
  $scope.doesPasswordExist = $scope.accountContent.userInfo.data.HasValidPasswordSet;

  $scope.layout = {
    showEditModal: true,
    isUpdatePhoneBusy: false,
    isVerifyPhoneBusy: false
  };

  $scope.getPhonePrefix = function() {
    if (!$scope.phoneInfo.phonePrefix) {
      return '';
    }

    return phoneConstants.phonePrefixCharacter + $scope.phoneInfo.phonePrefix.prefix;
  };

  $scope.clearDeletePhoneError = function() {
    $scope.layout.deletePhoneError = null;
  };

  $scope.clearUpdatePhoneError = function() {
    $scope.layout.updatePhoneError = null;
  };

  $scope.clearCodeError = function() {
    $scope.layout.codeError = null;
  };

  $scope.clearPhone = function() {
    $scope.phoneInfo.phone = null;
  };

  $scope.updatePhone = function() {
    $scope.layout.isUpdatePhoneBusy = true;
    $scope.clearUpdatePhoneError();
    if (!$scope.doesPasswordExist) {
      $scope.phoneInfo.password = 'placeholder';
    }
    const updatedPhoneInfo = {
      countryCode: $scope.phoneInfo.phonePrefix.code,
      prefix: $scope.phoneInfo.phonePrefix.prefix,
      phone: $scope.phoneInfo.phone,
      password: $scope.phoneInfo.password
    };

    accountsService
      .beginAccountUpdatePhone(updatedPhoneInfo)
      .then(
        function() {
          $scope.layout.showEditModal = false;
          $scope.layout.showVerifyModal = true;
          $scope.layout.focusOnCodeInput = true;
        },
        function(error) {
          $scope.layout.updatePhoneError = accountsService.getPhoneErrorMessageFromCode(error);
        }
      )
      .finally(function() {
        $scope.layout.isUpdatePhoneBusy = false;
      });
  };

  $scope.initiateDeletePhone = function() {
    $scope.layout.showEditModal = false;
    $scope.layout.showDeleteModal = true;
  };

  $scope.deletePhone = function() {
    $scope.layout.isDeletePhoneBusy = true;
    $scope.clearDeletePhoneError();
    const deleteInfo = {
      password: $scope.phoneInfo.password
    };

    accountsService
      .beginAccountDeletePhone(deleteInfo)
      .then(
        function() {
          const successData = {
            message: modalConstantsService.phoneSet.deleteSuccessMessage
          };
          $uibModalInstance.close(successData);
        },
        function(error) {
          $scope.layout.deletePhoneError = accountsService.getPhoneErrorMessageFromCode(error);
        }
      )
      .finally(function() {
        $scope.layout.isDeletePhoneBusy = false;
      });
  };

  $scope.submitCode = function() {
    $scope.layout.isVerifyPhoneBusy = true;
    $scope.clearCodeError();

    if (numericCodeService.checkCode($scope.phoneInfo.code, $scope.phoneModalData.codeLength)) {
      const codeInfo = {
        code: $scope.phoneInfo.code
      };

      accountsService
        .beginAccountVerifyPhone(codeInfo)
        .then(
          function success() {
            const successData = {
              message: modalConstantsService.phoneSet.updateSuccessMessage
            };
            $uibModalInstance.close(successData);
          },
          function(error) {
            $scope.layout.codeError = accountsService.getPhoneErrorMessageFromCode(error);
          }
        )
        .finally(function() {
          $scope.layout.isVerifyPhoneBusy = false;
        });
    } else {
      $scope.layout.isVerifyPhoneBusy = false;
      $scope.layout.codeError = `Code must be ${$scope.phoneModalData.codeLength} digits`;
    }
  };

  $scope.resendCode = function() {
    $scope.layout.isVerifyPhoneBusy = true;
    $scope.clearCodeError();

    accountsService
      .beginAccountResendPhoneCode()
      .then(
        function success(result) {
          if (!result.isValid) {
            $scope.layout.codeError = result.data;
          }
        },
        function() {
          $scope.layout.codeError = modalConstantsService.default.errorMessage;
        }
      )
      .finally(function() {
        $scope.layout.isVerifyPhoneBusy = false;
      });
  };

  $scope.selectPhonePrefix = function() {
    // Find the selected phone prefix looking at BOTH country code and prefix
    $scope.phoneInfo.phonePrefix = _.find($scope.accountInfoSettings.phonePrefixes, function(
      phonePrefix
    ) {
      return (
        phonePrefix.prefix === $scope.phoneModalData.prefix &&
        phonePrefix.code === $scope.phoneModalData.countryCode
      );
    });

    // Set to first selection as default
    if (!$scope.phoneInfo.phonePrefix) {
      $scope.phoneInfo.phonePrefix = $scope.accountInfoSettings.phonePrefixes[0];
    }
  };

  $scope.init = function() {
    if ($scope.phoneModalData.maskedNumber) {
      const lastDigits = $scope.phoneModalData.maskedNumber
        ? $scope.phoneModalData.maskedNumber.match(/\d+$/)
        : null;
      $scope.phoneModalData.lastDigits = lastDigits ? lastDigits[0] : null;
    }

    if ($scope.accountInfoSettings.phonePrefixes) {
      $scope.selectPhonePrefix();
    } else {
      phoneService.getPhonePrefixes($scope.accountContent.userInfo.data.ApiProxyDomain).then(
        function success(data) {
          $scope.accountInfoSettings.phonePrefixes = data;

          if (!$scope.accountInfoSettings.phonePrefixes) {
            $scope.layout.countryError = modalConstantsService.phoneSet.countryListErrorMessage;
            return;
          }

          $scope.selectPhonePrefix();
        },
        function() {
          $scope.layout.countryError = modalConstantsService.phoneSet.countryListErrorMessage;
        }
      );
    }
  };

  $scope.init();
}

accountSettingsModule.controller(
  'accountSettingsModalPhoneSetController',
  accountSettingsModalPhoneSetController
);

export default accountSettingsModalPhoneSetController;
